import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { useTranslation } from "react-i18next";

export type EudrTermKey = "dds" | "geolocation" | "deforestationRisk" | "riskScore" | "providerMode";

type Props = {
  term: EudrTermKey;
  /** Optional override for aria / test id suffix */
  testId?: string;
};

/** US-700: compact “what is this?” tooltip for EUDR jargon. */
export function EudrTermHint({ term, testId }: Props) {
  const { t } = useTranslation();
  const title = t(`compliance.glossary.${term}.title`);
  const body = t(`compliance.glossary.${term}.body`);
  return (
    <Tooltip
      title={
        <span>
          <strong>{title}</strong>
          <br />
          {body}
        </span>
      }
    >
      <button
        type="button"
        className="eudr-term-hint"
        data-testid={testId || `eudr-term-hint-${term}`}
        aria-label={title}
        onClick={(e) => e.preventDefault()}
      >
        <InfoCircleOutlined />
      </button>
    </Tooltip>
  );
}
